import React from "react";
import style from "../css/Warn.css";

export default class TestDetail extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            active: 1,
            data: {
                file_name: "",
                content: "",
            },
        };
    }


    render() {
        return (
            <div>
                <h1 className={style.title}>
                    请使用微信浏览器打开此网页，可省去手机号码验证步骤！！！设置步骤如下：
                </h1>
                <img
                    src={require("../static/warn1.jpg")}
                    alt=""
                    style={{width: "80%", margin: "0 10%"}}
                />
                <img
                    src={require("../static/warn2.jpg")}
                    alt=""
                    style={{width: "80%", margin: "0 10%"}}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/pages/Warn.js